import React, { useEffect, useState, FC } from 'react'
import { Button, Col, Row, Card, Image, message, Popconfirm, Pagination, Typography } from 'antd'
import { getMaterialTemplateList, deleteMaterialTemplate } from '@/services/creativeMaterialService'
import moment from 'moment'
import { RouteComponentProps } from 'react-router-dom'
import './materialList.scss'
const PageSize = 8
const MaterialList: FC<RouteComponentProps> = props => {
  const [templateList, setTemplateList] = useState<any>({ template: [], total: 0 })
  const [pageNumber, setPageNumber] = useState(1)
  const getTemplateList = (from: number, to: number) => {
    getMaterialTemplateList(from, to).then(res => {
      setTemplateList(res.data)
    })
  }
  useEffect(() => {
    getTemplateList((pageNumber - 1) * PageSize, pageNumber * PageSize)
  }, [pageNumber])
  const handleDeleteTemplate = (id: string) => {
    deleteMaterialTemplate(id).then(() => {
      message.success('删除成功')
      getTemplateList((pageNumber - 1) * PageSize, pageNumber * PageSize)
    })
  }
  const handleUseTemplate = (id: string, type: 'import' | 'editor') => {
    props.history.push(`/material/editor/${id}/${type}`)
  }
  const handlePageChange = (pageNumber: number) => {
    setPageNumber(pageNumber)
  }
  return (
    <div className="material-list-wrapper">
      <Row gutter={24}>
        {templateList.template.map(item => (
          <Col span={6} key={item.id} style={{ marginBottom: 15 }}>
            <Card
              hoverable
              cover={<Image src={item.link} />}
              actions={[
                <Button
                  type="primary"
                  key="import"
                  onClick={() => {
                    handleUseTemplate(item.id, 'import')
                  }}
                >
                  导入
                </Button>,
                <Button
                  key="editor"
                  type="primary"
                  onClick={() => {
                    handleUseTemplate(item.id, 'editor')
                  }}
                >
                  修改
                </Button>,
                <Popconfirm
                  key="delete"
                  title="确认删除模板?"
                  onConfirm={() => {
                    handleDeleteTemplate(item.id)
                  }}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button type="primary" danger>
                    删除
                  </Button>
                </Popconfirm>,
              ]}
            >
              <Row gutter={24}>
                <Col span={24}>
                  <Typography.Text>{`作者: ${item.author}`}</Typography.Text>
                </Col>
                <Col span={24}>
                  <Typography.Text>
                    {`创建时间: ${moment(item.created_at).format('YYYY-MM-DD HH:mm:ss')}`}
                  </Typography.Text>
                </Col>
                <Col span={24}>
                  <Typography.Text>
                    {`上次编辑: ${moment(item.last_modified_at).format('YYYY-MM-DD HH:mm:ss')}`}
                  </Typography.Text>
                </Col>
              </Row>
            </Card>
          </Col>
        ))}
      </Row>
      <Pagination
        onChange={handlePageChange}
        pageSize={PageSize}
        current={pageNumber}
        total={templateList.total}
        showSizeChanger={false}
      />
    </div>
  )
}

export default MaterialList
